import { render, staticRenderFns } from "./index_JianKang.vue?vue&type=template&id=70625ec1&scoped=true"
import script from "./index_JianKang.vue?vue&type=script&lang=js"
export * from "./index_JianKang.vue?vue&type=script&lang=js"
import style0 from "./index_JianKang.vue?vue&type=style&index=0&id=70625ec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70625ec1",
  null
  
)

export default component.exports